import {OfficeTypes} from "./actionsTypes";

// Getting
export const getOffices = (next_page: string, filter: object) => ({
    type: OfficeTypes.GET_OFFICES,
    next_page,
    filter
})
export const getOfficesSuccess = (data: any) => ({
    type: OfficeTypes.GET_OFFICES_SUCCESS,
    payload: data,
})

export const getOfficesFail = (error: any) => ({
    type: OfficeTypes.FAIL_OFFICES,
    payload: error,
})

// Adding
export const addOffice = (data: any) => ({
    type: OfficeTypes.ADD_OFFICE,
    data
})

export const addOfficeSuccess = (data: any) => ({
    type: OfficeTypes.ADD_OFFICE_SUCCESS,
    payload: data
})

export const addOfficeFail = (error: any) => ({
    type: OfficeTypes.FAIL_OFFICES,
    payload: error,
})

// Other
export const clearOffices = () => ({
    type: OfficeTypes.CLEAR_OFFICES,
})

export const modalOffice = (status: boolean) => ({
    type: OfficeTypes.MODAL_OFFICE,
    status
})